import React, { RefObject, useMemo } from "react";
import { FormProps } from "semantic-ui-react";
import SchemaForm from "../schema/SchemaForm";
import IFormDefinition from "../../interfaces/IFormDefinition";
import { transformObservationSchema } from "../../utils/observation.helpers";
import { IFormSchema } from "../../interfaces/IFormSchema";



export interface ObservationFormProps extends Omit<FormProps, "onChange" | "onSubmit"> {
    formData: { [key: string]: any }
    onChange: (values: { [key: string]: any }) => void;
    onSubmit: (values: { [key: string]: any }, observationSchema: IFormSchema) => void;

    formDefinition: IFormDefinition;
    submitButton: RefObject<HTMLButtonElement>;
};

export const ObservationForm: React.FC<ObservationFormProps> = ({
    formData,

    onChange: updateFormData,
    onSubmit: submit,

    formDefinition,

    submitButton,
    ...formProps
}) => {

    const modifiedSchema = useMemo(() => {
        return transformObservationSchema(formDefinition.schema);
    }, [formDefinition]);


    return (
        <SchemaForm
            {...modifiedSchema}
            formData={formData}
            onSubmit={(values) => submit(values, formDefinition.schema)}
            onChange={(form) => updateFormData(form.formData)}
            ErrorList={(form) => null}
        >
            <button ref={submitButton} type="submit" style={{ display: "none", opacity: 0 }} />
        </SchemaForm>
    );
};


